import { Component, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { BaseServiceService } from "src/app/services/base-service.service";
import { Formulario } from "../form/form.component";
import { DataTableDirective } from "angular-datatables";
import {
  ModalNotifyComponent,
  ModalNotifyTypes,
} from "../modal-notify/modal-notify.component";
import { AppData } from "src/app/helpers/app-data";
import { HttpClient } from "@angular/common/http";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

import { lastValueFrom } from "rxjs";

declare var fabric: any;

@Component({
  selector: "app-datatable-formularios",
  templateUrl: "./datatable-formularios.component.html",
  styleUrl: "./datatable-formularios.component.css",
})
export class DatatableFormulariosComponent {
  dialogComponentCreate: any;
  dialogComponentEdit: any;
  dialogComponentDuplicarFormulario: any;
  formSubmitted: boolean = false;
  botonProcesando = false;
  getDataTableFormularios: any = ["Formulario", "GetDataTableFormulario"];

  textoBotonProcesando = "Cargando...";
  id: any;
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;

  @ViewChild(DataTableDirective, { static: false })
  dtElement: any;
  dtInstance: DataTables.Api;

  dtOptions: DataTables.Settings = {};
  dtOptButtons: any = [];

  response: any[] = [];
  titulo: string = "";
  internalDescription: string = "";
  dtTrigger: any;
  valorCompartido: any;
  validateDel: boolean = false;
  dialogComponentCreateFormulario: any;

  idFormulario: any;
  formForm: FormGroup;
  formularioObj: Formulario;
  formularioDuplicado: any = '';

  auxImport: boolean = false;
  isEmpty: any = null;
  selectedFile: any;
  dialogComponentImportarFormulario: any;

  booleanColumnRenderer = (data: any, type: any, row: any, meta: any) => {
    if (type === "display") {
      return `<input type="checkbox" disabled ${data ? "checked" : ""}>`;
    }
    return data;
  };
  columnas = [
    { title: "ID", data: "Id" },
    { title: "Duplicado de", data: "NombrePadre" },    
    { title: "Nombre", data: "Nombre" },
    { title: "Descripcion", data: "Descripcion" },
    { title: "Estado", data: "Estado" },
    { title: "Version", data: "Version" },
    { title: "Fecha Creación", data: "FechaCreacionFormulario" },
    { title: "Usuario Creación", data: "UsuarioCreacion" },
    { title: "Fecha Actualización", data: "FechaActualizacionFormulario" },
    { title: "Usuario Actualización", data: "UsuarioActualizacion" },
    {
      title: "Todos Usuarios",
      data: "TodosUsuarios",
      render: this.booleanColumnRenderer,
      orderable: false,
    },
    {
      title: "Activo",
      data: "Activo",
      render: this.booleanColumnRenderer,
      orderable: false,
    },
  ];

  constructor(
    private baseService: BaseServiceService,
    private router: Router,
    private renderer: Renderer2,
    private http: HttpClient,
    private _formBuilder: FormBuilder
  ) {
    this.formularioObj = new Formulario();
    this.formInit();
  }

  abrirDiagramador() {
    this.router.navigate(["home/design-form"]);
  }

  async ngOnInit(): Promise<void> {
    this.dtOptButtons.push(
      { "button-id": "btnEdit", "button-icon": "ms-Icon--EditNote", "button-tooltip": "Editar Datos" },
      { "button-id": "btnCopyProcess", "button-icon": "ms-Icon--Copy", "button-tooltip": "Duplicar Formulario" },
      {
        "button-id": "btnImport",
        "button-icon": "ms-Icon--Upload",
        "button-tooltip": "Importar",
        'conditional-data': [{ key: 'isempty', value: 'IsEmpty' }]
      },
      {
        "button-id": "btnExport",
        "button-icon": "ms-Icon--Download",
        "button-tooltip": "Exportar",
      },
      {
        "conditional-column": "Estado",
        "conditional-datatype": "string",
        "conditional-value": "Produccion",
        "button-id": "btnEditForm",
        "button-icon": "ms-Icon--WindowEdit",
        "conditional-comparison": "not-equals",
        "button-tooltip": "Editar Formulario"
      }
    );

    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      searching: true,
      ordering: true,
      ajax: async (dataTablesParameters: any, callback) => {
        this.http
          .post<any>(
            AppData.API_URL + this.getDataTableFormularios,
            dataTablesParameters
          )
          .subscribe((resp) => {
            const dataWithEstadoText = resp.Data.data.map((item: any) => {
              return {
                ...item,
                Estado: this.getEstadoText(item.Estado),
              };
            });
            callback({
              draw: resp.Data.draw,
              recordsTotal: resp.Data.recordsTotal,
              recordsFiltered: resp.Data.recordsFiltered,
              data: dataWithEstadoText,
            });
          });
      },

      language: {
        url: "../../../assets/es-ES.json",
      },
      columns: [
        ...this.columnas,
        {
          title: "Opciones",
          data: "Id",
          orderable: false,
          render: (data: any, type: any, full: any) => {
            // Inicializar botones existentes
            let buttons = `
            <button class="ms-CommandButton-button" data-id="${full.Id}" id="btnEdit">
              <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--EditNote"></i></span>
            </button>
            <button class="ms-CommandButton-button" type="button" id="btnDelete" data-id="${full.Id}">
              <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
            </button>
            <button class="ms-CommandButton-button" type="button" id="btnCopyProcess" data-id="${full.Id}">
              <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Copy"></i></span>
            </button>
          `;
            if (full.Estado !== "Produccion") {
              buttons += `
              <button class="ms-CommandButton-button" type="button" id="btnEditForm" data-id="${full.Id}">
              <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--WindowEdit"></i></span>
            </button>
          `;
            }
            // Agregar botón "Acceso" si todosusuarios es false
            /*  if (!full.TodosUsuarios) {
              buttons += `
              <button class="ms-CommandButton-button" type="button" id="btnAccess" data-id="${full.Id}">
                <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--UserFollowed"></i></span>
                
              </button>
            `;
            } */

            return buttons;
          },
        },
      ],
    };

    var DatePickerElements = document.querySelectorAll(".ms-DatePicker-holder");
    for (var i = 0; i < DatePickerElements.length; i++) {
      new fabric["DatePicker"](DatePickerElements[i]);
    }

    var SpinnerElements = document.querySelectorAll(".ms-Spinner");
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric["Spinner"](SpinnerElements[i]);
    }

    var CheckBoxElements = document.querySelectorAll(".ms-CheckBox");
    for (var i = 0; i < CheckBoxElements.length; i++) {
      new fabric["CheckBox"](CheckBoxElements[i]);
    }
  }

  ngAfterViewInit(): void {
    /*     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.on("draw", () => {
        this.attachClickEvents();
      });
    }); */
  }

  ngOnDestroy(): void {
    // Destroy the DataTables when the component is destroyed to prevent memory leaks
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.off("draw");
      });
    }
  }

  gridLoaded(event: any) {
    this.dtInstance = event["table"];
  }

  customClick(event: any) {
    try {
      
      this.idFormulario = event["data-id"];

      switch (event["button-id"]) {
        case "btnEdit":
          this.abrirModalEditar();
          break;
        case "btnDelete":
          this.delete(Number(this.idFormulario));
          break;
        case "btnCopyProcess":
          this.abrirModalDuplicar();
          break;
        case "btnEditForm":
          this.baseService.exportIDForm(this.idFormulario);
          this.abrirEditorFormularios();
          break;
        case "btnImport":
          this.auxImport = true;
          this.isEmpty = event['data-isempty'];

          this.abrirModalImportar();
          break;
        case "btnExport":
          this.auxImport = false;

          this.exportarFormulario();
          break;
      }
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }

  formInit() {
    this.formForm = this._formBuilder.group({
      Nombre: new FormControl("", [
        Validators.required,
        Validators.maxLength(200),
      ]),
      Descripcion: new FormControl("", [
        Validators.required,
        Validators.maxLength(700),
      ]),
      Estado: new FormControl("", [Validators.required]),
      Version: new FormControl(null, [Validators.required]),
      TodosUsuarios: new FormControl(false),
      Activo: new FormControl(false),
    });
  }

  attachClickEvents(): void {
    const editButtons = document.querySelectorAll("#btnEdit");
    const deleteButtons = document.querySelectorAll("#btnDelete");
    const editFormButtons = document.querySelectorAll("#btnEditForm");
    const copyProcessButton = document.querySelectorAll("#btnCopyProcess");

    editButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const id = button.getAttribute("data-id");
        this.idFormulario = id;
        this.abrirModalEditar();
      });
    });

    deleteButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const userId = button.getAttribute("data-id");
        this.delete(Number(userId));
      });
    });
    editFormButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const userId = button.getAttribute("data-id");
        this.baseService.exportIDForm(userId);
        this.abrirEditorFormularios();
      });
    });
    copyProcessButton.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const formId = button.getAttribute("data-id");
        this.idFormulario = formId;
        this.abrirModalDuplicar();
      });
    });
  }

  async edit(userId: number) {
    try {
      await this.baseService.setIdSeleccionado(userId);
      this.baseService.abrirModalEditar();
    } catch (error) {
      console.error("Error al establecer el ID:", error);
    }
  }

  async delete(userId: number) {
    try {
      this.baseService.triggerShowModal(
        "Eliminar Formulario",
        "¿Seguro que desea eliminar el Formulario?",
        ModalNotifyTypes.Warning,
        true
      );

      this.modalNotifyComponent.actionConfirmed.subscribe(
        (confirmed: boolean) => {
          if (confirmed) {
            this.baseService
              .delete("Formulario/BorrarFormulario", userId)
              .then(() => {
                this.reloadDataTable();
                this.baseService.triggerShowModal(
                  "Formulario Eliminado",
                  "Formulario Eliminado Correctamente",
                  ModalNotifyTypes.Success,
                  false
                );
              });
          } else {
          }
        }
      );
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error al enviar el formulario:",
        error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  reloadDataTable(): void {
    this.dtInstance.ajax.reload(null, false);

   /*  this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload(null, false);
    }); */
  }

  clearFormFormularioCreado() {
    this.formularioObj = new Formulario();
    this.formForm.reset();
    this.baseService.clearForm();
  }
// 
  clearFormFormulario() {

    this.baseService.triggerShowModal(
      "Cancelar creacion de formulario",
      "¿Seguro que desea cancelar la creacion del formulario?",
      ModalNotifyTypes.Warning,
      true
    );

    //this.baseService.clearForm();

    this.modalNotifyComponent.actionConfirmed.subscribe(
      (confirmed: boolean) => {
        console.log(confirmed);
        
        if (confirmed) {
          this.formularioObj = new Formulario();
          this.formForm.reset();
          this.baseService.clearForm();
          this.dialogComponentCreateFormulario.close();

         
        } else {
          // Si se cancela la eliminación, no hacemos nada
        }
      }
    );
  }
  
  dialogComponent;

  abrirModalCrear() {
    this.clearFormFormularioCreado();
    $("#dialogCreateEdit").html("Crear Formulario");
    $("#btnCreateEdit > span").html("Crear");
    $("#estadoFormulario").prop("disabled", false);
    this.formForm.controls["Activo"].setValue(true);

    const dialog = document.querySelector(".create-formulario");
    this.dialogComponentCreateFormulario = new fabric["Dialog"](dialog);
    this.dialogComponentCreateFormulario.open();
  }

  async crearEditarFormulario() {
    this.botonProcesando = true;
    this.formularioObj.Nombre = this.formForm.get("Nombre").value;
    this.formularioObj.Descripcion = this.formForm.get("Descripcion").value;
    //this.procesoObj.Estado = parseInt(this.processForm.get('Nombre').value);
    this.formularioObj.Version = this.formForm.get("Version").value;
    this.formularioObj.TodosUsuarios = this.formForm.get("TodosUsuarios").value;
    this.formularioObj.Activo = this.formForm.get("Activo").value;
    this.formularioObj.Estado = parseInt(this.formularioObj.Estado as any);

    try {
      if (this.idFormulario) {
        const response = await this.baseService.update(
          "Formulario/ActualizarFormulario",
          this.idFormulario,
          this.formularioObj
        );

        if (!response.Ok) {
          this.dialogComponentCreateFormulario.close();

          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al editar Formulario",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          this.dialogComponentCreateFormulario.close();
          this.baseService.triggerShowModal(
            "Formulario Editado",
            "Se ha almacenado el registro correctamente ",
            ModalNotifyTypes.Success,
            false
          );
          this.botonProcesando = false;
          this.reloadDataTable();
        }
      } else {
        const response = await this.baseService.create(
          "Formulario/CrearFormulario",
          this.formularioObj
        );

        if (!response.Ok) {
          this.dialogComponentCreateFormulario.close();

          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al crear Formulario",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          this.dialogComponentCreateFormulario.close();

          var example = document.querySelector(".success");

          var dialog = example.querySelector(".modal-succes");

          this.dialogComponent = new fabric["Dialog"](dialog);

          this.dialogComponent.open();

          this.botonProcesando = false;
          //this.clearFormFormularioCreado();
          this.reloadDataTable();

        }
      }
      

    } catch (error: any) {

      this.dialogComponentCreateFormulario.close();

      let mensajeError = error.error.Error;
      
      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }

  cerrarModalFormularioGuardado() {
    this.dialogComponent.close();
    this.reloadDataTable();
  }

  abrirEditorFormularios() {
    this.router.navigate(["home/design-form"]);
  }

  async abrirModalEditar() {
    try {
      if (this.idFormulario !== null) {
        const responseById = await this.baseService.getById(
          "Formulario/GetFormulario",
          this.idFormulario
        );
        if (responseById.Data) {
          const Data = responseById.Data;
          this.formForm.controls["Nombre"].setValue(Data.Nombre);
          this.formForm.controls["Descripcion"].setValue(Data.Descripcion);
          this.formForm.controls["Estado"].setValue(Data.Estado);
          this.formForm.controls["Version"].setValue(Data.Version);
          this.formForm.controls["TodosUsuarios"].setValue(Data.TodosUsuarios);
          this.formForm.controls["Activo"].setValue(Data.Activo);
          // this.formularioObj.Nombre = Data.Nombre;
          // this.formularioObj.Descripcion = Data.Descripcion;
          this.formularioObj.Estado = Data.Estado;
          // this.formularioObj.Version = Data.Version;
          // this.formularioObj.TodosUsuarios = Data.TodosUsuarios;
          // this.formularioObj.Activo = Data.Activo;

          $("#dialogCreateEdit").html("Editar Formulario");
          $("#btnCreateEdit > span").html("Actualizar");

          if (Data.Estado == 3) {
            $("#estadoFormulario").prop("disabled", true);
          } else {
            $("#estadoFormulario").prop("disabled", false);
          }
          const selectedOption =
            document.querySelectorAll(".ms-Dropdown-title");

          const dialog = document.querySelector(".create-formulario");

          this.dialogComponentCreateFormulario = new fabric["Dialog"](dialog);
          this.dialogComponentCreateFormulario.open();
        }
      }
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error",
        error.Error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }
  getEstadoText(estado: number) {
    switch (estado) {
      case 1:
        return "Diseño";

      case 2:
        return "Pruebas";

      case 3:
        return "Produccion";

      default:
        break;
    }
  }

  abrirModalDuplicar() {
    const dialog = document.querySelector(".modal-duplicar");
    this.dialogComponentDuplicarFormulario = new fabric["Dialog"](dialog);
    this.dialogComponentDuplicarFormulario.open();
  }

  async duplicarFormulario() {
    this.botonProcesando = true;
    /*     this.formularioObj = new Formulario();

    const responsebyIdConfiguracion = await this.baseService.getById(
      "Formulario/GetFormularioConfiguracion",
      this.idFormulario
    );
    const dataConfig = responsebyIdConfiguracion.Data;
    const responsebyIdFormulario = await this.baseService.getById(
      "Formulario/GetFormulario",
      this.idFormulario
    );
    const dataFormulario = responsebyIdFormulario.Data;

    if (responsebyIdConfiguracion) {
      this.formularioObj.Configuracion = dataConfig.Configuracion;
    }
    if (responsebyIdFormulario) {
      this.formularioObj.Nombre = dataFormulario.Nombre;
      this.formularioObj.Descripcion = dataFormulario.Descripcion;
      this.formularioObj.Estado = dataFormulario.Estado;
      this.formularioObj.Version = dataFormulario.Version + 1;
      this.formularioObj.TodosUsuarios = dataFormulario.TodosUsuarios;
      this.formularioObj.Activo = dataFormulario.Activo;
    }
    console.log(this.formularioObj);
    
     */
    try {
      const response = await lastValueFrom(
        this.http.post<any>(
          AppData.API_URL +
            "Formulario/ClonarFormulario?Id=" +
            this.idFormulario,
          null
        )
      );

      if (!response.Ok) {
        this.dialogComponentDuplicarFormulario.close();

        let mensajeError = "<ul>";
          
        response.ValidationErrors.forEach((error: any) => {
          mensajeError += `<li>${error}</li>`;
        });
        mensajeError += "</ul>";

        this.baseService.triggerShowModal(
          "Error al duplicar Formulario",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      } else {
        this.dialogComponentDuplicarFormulario.close();

        var example = document.querySelector(".duplicado");
        

        this.formularioDuplicado = response.Data['Nombre'];

        var dialog = example.querySelector(".duplicado-succes");

        this.dialogComponent = new fabric["Dialog"](dialog);

        this.dialogComponent.open();

        this.botonProcesando = false;
        this.reloadDataTable();
      }
    } catch (error) {
      this.dialogComponentDuplicarFormulario.close();

        let mensajeError = "<ul>";
          
          mensajeError += `<li>${error.error.Error}</li>`;
        
        mensajeError += "</ul>";

        this.baseService.triggerShowModal(
          "Error al duplicar Formulario",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;

    }
  }
  onInputChange(event: Event): void {
  const inputElement = event.target as HTMLInputElement;
  if (inputElement.valueAsNumber < 0) {
    inputElement.value = '0'; // Restablece a 0 si el valor es negativo
  }
}

  abrirModalImportar() {
    // Abrir el explorador de archivos para seleccionar un archivo JSON con la configuración del formulario
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".json"; // Aceptar solo archivos .json

    input.onchange = async () => {
      const file = input.files ? input.files[0] : null;

      if (file) {
        var ext = file.name.split(".").pop().toLowerCase();
        if (ext !== "json") {
          let mensajeError =
            "Extensión " +
            ext +
            " no válida, por favor cargue un archivo con extensión .json";
          this.baseService.triggerShowModal(
            "Error al importar Formulario",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          return;
        }

        const fileContent = await file.text();
        try {
          JSON.parse(fileContent);
        } catch (error) {
          this.baseService.triggerShowModal(
            "Error al importar Formulario",
            "El archivo seleccionado no contiene un JSON válido.",
            ModalNotifyTypes.Danger,
            false
          );
          return;
        }

        // Guardar el archivo seleccionado para usarlo después
        this.selectedFile = file;

        // Abrir el modal de confirmación
        const dialog = document.querySelector(".modal-Importar-formulario");
        this.dialogComponentImportarFormulario = new fabric["Dialog"](dialog);
        this.dialogComponentImportarFormulario.open();
      } else {
        this.baseService.triggerShowModal(
          "Error",
          "No se seleccionó ningún archivo.",
          ModalNotifyTypes.Danger,
          false
        );
      }
    };

    // Simular el clic en el input para abrir el explorador de archivos
    input.click();
  }

  async importarFormulario() {
    this.botonProcesando = true;

    if (this.selectedFile && this.idFormulario !== null) {
      const fileContent = await this.selectedFile.text();

      try {
        const response = await lastValueFrom(
          this.http.post<any>(
            `${AppData.API_URL}Formulario/ActualizarFormularioConfiguracion?Id=${Number(
              this.idFormulario
            )}`,
            {
              Configuracion: fileContent,
            },
            {
              headers: { "Content-Type": "application/json" },
            }
          )
        );

        if (!response.Ok) {
          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al importar Formulario",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          var example = document.querySelector(".importado-formulario");
          var dialog = example.querySelector(".importado-formulario-succes");

          this.dialogComponent = new fabric["Dialog"](dialog);
          this.dialogComponent.open();

          this.botonProcesando = false;
          this.reloadDataTable();
        }
      } catch (error: any) {
        let mensajeError = error.error?.Error ?? "Error al importar el formulario.";

        this.baseService.triggerShowModal(
          "Error",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      }
    } else {
      this.baseService.triggerShowModal(
        "Error",
        "No se seleccionó ningún archivo o el formulario no es válido.",
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }

    this.dialogComponentImportarFormulario.close();
  }

  async exportarFormulario() {
    if (this.idFormulario === null) {
      return;
    }

    const responseById = await this.baseService.getById(
      "Formulario/GetFormularioConfiguracion",
      this.idFormulario
    );

    if (!responseById.Ok) {
      let mensajeError = "<ul>";
      responseById.ValidationErrors.forEach((error: any) => {
        mensajeError += `<li>${error}</li>`;
      });
      mensajeError += "</ul>";

      this.baseService.triggerShowModal(
        "Error al exportar Formulario",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
      return;
    }

    let jsonData = (responseById.Data.Configuracion || "").trim();
    try {
      // Se formatea el JSON para que el archivo exportado quede legible
      jsonData = JSON.stringify(JSON.parse(jsonData), null, 2);
    } catch (error) {
      // Si por alguna razón no es un JSON válido, se exporta tal cual quedó almacenado
    }

    const blob = new Blob([jsonData], {
      type: "application/json;charset=utf-8",
    });

    const link = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `${responseById.Data.Nombre || "formulario"}.json`
    );
    link.style.display = "none";

    document.body.appendChild(link);

    setTimeout(() => {
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);
  }

}
